<template>
  <v-row class="ma-0">
    <v-col cols="12">
      <h3>{{ $t('Seleção de indicadores') }}</h3>
      <span>{{ $t('Marque os indicadores para a exportação') }}</span>
    </v-col>

    <v-col
      cols="12"
      md="6"
      v-for="cat in visibleCategories"
      :key="cat.id"
    >
      <strong>{{ $t(cat.nameKey) }}</strong>
      <v-checkbox
        v-for="ind in getVisibleIndicators(cat.id)"
        :key="ind.id"
        v-model="selection"
        :label="`${cat.prefix}.${ind.displayNumber} - ${$t(ind.nameKey)}`"
        :value="ind.legacyKey"
        hide-details
      ></v-checkbox>

      <v-divider
        v-if="cat.id === 'quantitative'"
        class="mt-4"
      ></v-divider>
    </v-col>

    <v-col cols="12">
      <v-card-actions class="justify-space-between">
        <v-btn text @click="$emit('back')">
          <v-icon>mdi-chevron-left</v-icon>
          {{ $t('Voltar') }}
        </v-btn>

        <v-spacer></v-spacer>

        <v-btn text @click="submit">
          {{ $t('Continuar') }}
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </v-card-actions>
    </v-col>
  </v-row>
</template>

<script>
import {
  CATEGORIES,
  getVisibleIndicators as _getVisibleIndicators,
} from '../../../indicators/indicatorRegistry'

export default {
  name: 'SelectInstStep',

  props: {
    selectionProp: Array,
  },

  watch: {
    selectionProp() {
      this.selection = this.selectionProp
    },
  },

  created() {
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.selection = this.selectionProp
  },

  data() {
    return {
      institution: {},
      selection: [],
    }
  },

  computed: {
    visibleCategories() {
      return CATEGORIES.filter(
        (cat) => _getVisibleIndicators(cat.id, this.institution).length > 0
      )
    },
  },

  methods: {
    getVisibleIndicators(categoryId) {
      return _getVisibleIndicators(categoryId, this.institution)
    },

    submit() {
      if (this.selection.length > 0) {
        this.$emit('next', this.selection)
      } else {
        this.$toast.warning('Selecione ao menos um indicador para prosseguir')
      }
    },
  },
}
</script>

<style scoped></style>
